import { render, staticRenderFns } from "./BrightcovePlayer.vue?vue&type=template&id=1a8639a2"
import script from "./BrightcovePlayer.vue?vue&type=script&lang=js"
export * from "./BrightcovePlayer.vue?vue&type=script&lang=js"
import style0 from "./BrightcovePlayer.vue?vue&type=style&index=0&id=1a8639a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports